import { render } from "./DataTableServerPagination.vue?vue&type=template&id=84e9f6c2"
import script from "./DataTableServerPagination.vue?vue&type=script&lang=js"
export * from "./DataTableServerPagination.vue?vue&type=script&lang=js"

import "./DataTableServerPagination.vue?vue&type=style&index=0&id=84e9f6c2&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__